import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import { ConfigProvider, App as AntApp } from 'antd';
import { StyleProvider, createCache } from '@ant-design/cssinjs';
import BaseRouter from './router';
import antdTheme from './themes/antdTheme';

const cache = createCache();

ReactDOM.render(
  <React.StrictMode>
    <StyleProvider cache={cache}>
      <RecoilRoot>
        <ConfigProvider theme={antdTheme}>
          <AntApp>
            <BaseRouter />
          </AntApp>
        </ConfigProvider>
      </RecoilRoot>
    </StyleProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
